export const loginUrl = 'auth/token/obtain/';
export const registerUrl = 'auth/signup/';
export const changePasswordUrl = 'auth/changepass/';
export const getVerificationCodeUrl = 'auth/sendVerify/';

export const getLandingDataUrl = 'people/';
